import React from 'react';
import './style.css';
import logo from './logo.png';
import {downloadTanTuTravel} from '../../../config';
import {parseQuery} from '../../../utils/url';
import * as navigator from '../../../native/navigator';

const query = parseQuery();
const CHANNEL = query.channel || '';


export default function DownloadBar(props) {


  return (
    <div className='download-bar'>
      <div className='container'>
        <div className='logo'>
          <img src={logo} alt='logo' />
        </div>
        <div className='slogan'>
          <h3>探途地图</h3>
          <p>轻松规划行程，探索世界美景</p>
        </div>
        <div className='btn'>
          <button onClick={() => {
            let url = 'http://uri6.com/tkio/QFRBRna';
            navigator.push(url);
          }}>下 载</button>
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Poi2/DownloadBar/index.js